import { HorizontalDots } from "../svg-organizer/SvgOrganizer";
import { CiCirclePlus } from "react-icons/ci";
import { useState } from "react";
import {
  Tag,
  SuccessTag,
  Checkbox,
  SmallCircle,
  Select,
  Button2,
  Button1,
} from "../index";
import downloadIcon from "../../assets/icons/download-cloud-icon.png";
import addIcon from "../../assets/icons/plus.png";
import { useNavigate } from "react-router-dom";
import refreshIcon from "../../assets/icons/refresh-icon.png";
import { Input, Popover, Switch } from "antd";
import downIcon from "../../assets/icons/chevron-down.png";
import editIcon from "../../assets/icons/edit-icon.png";
import reportIcon from "../../assets/icons/report.png";
import downGreenIcon from "../../assets/icons/down-green-icon.png";
import receiptCheck from "../../assets/icons/receipt-check-white.png";
import { FiArrowDownLeft, FiArrowUpRight } from "react-icons/fi";

const checkbox = <Checkbox />;

const renderWallet1Table = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  p-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.onToggle ? (
          <Checkbox checked={!!tr.selected} onChange={tr.onToggle} />
        ) : (
          checkbox
        )}
      </td>

      <td
        className={`align-middle p-4 ps-0 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex gap-2 p-0">
          <img
            src={tr.currencyData.icon}
            className="image-fluid"
            width={40}
            alt=""
            height={40}
          />
          <div className="d-flex flex-column">
            <span className="fw-medium">{tr.currencyData.currencyName}</span>

            <span style={{ fontSize: "12px" }}>
              {tr.currencyData.currencyType}
            </span>
          </div>
        </div>
      </td>

      <td
        className={`align-middle p-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.category}
      </td>

      <td
        className={`align-middle p-4  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.tags}
      </td>

      <td
        className={`align-middle p-4 text-center  fw-semibold ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "var(--accent-color)" }}
      >
        {tr.globalAccount}
      </td>

      <td
        className={`align-middle p-4 ps-2  text-center  ${
          key === bodyLength && "border-bottom-0"
        } `}
        style={{ color: "var(--text-muted)" }}
      >
        {tr.availableBalance}
      </td>
    </>
  );
};

const renderWallet2Table = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  p-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {checkbox}
      </td>

      <td
        className={`align-middle p-4 ps-0 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex gap-2 p-0">
          <img
            src={tr.currencyData.icon}
            className="image-fluid"
            width={40}
            alt=""
            height={40}
          />
          <div className="d-flex flex-column">
            <span className="fw-medium">{tr.currencyData.currencyName}</span>

            <span style={{ fontSize: "12px" }}>
              {tr.currencyData.currencyType}
            </span>
          </div>
        </div>
      </td>

      <td
        className={`align-middle p-4 text-center ps-2  fw-semibold ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "var(--accent-color)" }}
      >
        {tr.globalAccount}
      </td>

      <td
        className={`align-middle p-4 ${
          key === bodyLength && "border-bottom-0"
        } `}
      >
        <div className="d-flex align-items-center gap-2">
          {tr.tags.map((tag) => {
            return <span>{tag}</span>;
          })}
          <CiCirclePlus className="fs-5" color="#1bbb6b" cursor={"pointer"} />
        </div>
      </td>

      <td
        className={`align-middle text-center p-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.category}
      </td>

      <td
        className={`align-middle p-4  opacity-50 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.availableBalance}
      </td>
    </>
  );
};

const renderWallet3Table = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  p-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {checkbox}
      </td>

      <td
        className={`align-middle p-4 ${
          key === bodyLength && "border-bottom-0"
        } `}
      >
        <div className="d-flex flex-column">
          <span>{tr.name.n1}</span>
          <span className="fs14px opacity-50">{tr.name.n2}</span>
        </div>
      </td>

      <td
        className={`align-middle p-4 ps-1 text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "var(--text-muted)" }}
      >
        {tr.bankLocation}
      </td>

      <td
        className={`align-middle p-4 ps-3 text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "var(--text-muted)" }}
      >
        {tr.accountNumber}
      </td>

      <td
        className={`align-middle p-4 ps-2 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <Tag
          tagName={tr.status}
          tagStyle={{
            background: "#EDF8F3",
            color: "#1BBB6B",
            fontSize: "11px",
          }}
          className={"rounded-1"}
        />
      </td>

      <td
        className={`align-middle p-4 ps-0 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex gap-2 p-0">
          <img
            src={tr.currencyData.icon}
            className="image-fluid"
            width={40}
            alt=""
            height={40}
          />
          <div className="d-flex flex-column">
            <span className="fw-medium">{tr.currencyData.currencyName}</span>

            <span style={{ fontSize: "12px" }}>
              {tr.currencyData.currencyType}
            </span>
          </div>
        </div>
      </td>
    </>
  );
};

const renderWallet4Table = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  p-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {checkbox}
      </td>

      <td
        className={`align-middle fs14px p-4 ps-0 opacity-75 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.date_time}
      </td>

      <td
        className={`align-middle p-4  ps-2 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <Tag
          tagName={tr.status}
          tagStyle={{
            background: "#EDF8F3",
            color: "#1BBB6B",
            fontSize: "11px",
          }}
          className={"rounded-1"}
        />
      </td>

      <td
        className={`align-middle p-4 ps-2    ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "var(--text-muted)" }}
      >
        {tr.type}
      </td>

      <td
        className={`align-middle p-4  text-center ps-0  ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "var(--text-muted)" }}
      >
        {tr.counterparty}
      </td>

      <td
        className={`align-middle p-4   ps-2 text-center${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "var(--text-muted)" }}
      >
        {tr.accNickName}
      </td>

      <td
        className={`align-middle p-4   ps-3 text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "var(--text-muted)" }}
      >
        {tr.accountNumber}
      </td>

      <td
        className={`align-middle p-4   ps-0 text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "var(--text-muted)" }}
      >
        {tr.amount}
      </td>
    </>
  );
};

const renderWallet5Table = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  p-3 ps-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.onToggle ? (
          <Checkbox checked={!!tr.selected} onChange={tr.onToggle} />
        ) : (
          checkbox
        )}
      </td>

      <td
        className={`align-middle fs14px   p-3 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.date_time}
      </td>

      <td
        className={`align-middle  p-3 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.status}
      </td>

      <td
        className={`align-middle   p-3 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.type}
      </td>

      <td
        className={`align-middle   p-3  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.details}
      </td>

      <td
        className={`align-middle text-center   p-3 fw-semibold ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "var(--accent-color)" }}
      >
        {tr.amount}
      </td>

      <td
        className={`align-middle text-center ps-4   p-3 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.currency}
      </td>

      <td
        className={`align-middle   p-3  text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "var(--text-muted)" }}
      >
        {tr.category}
      </td>

      <td
        className={`align-middle   p-3 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex flex-wrap align-items-center gap-2">
          {tr.tags.map((tag) => {
            return <span>{tag},</span>;
          })}
          <CiCirclePlus className="fs-5 cursor-pointer" color="#1bbb6b" />
        </div>
      </td>

      <td
        className={`align-middle    p-3  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.spill}
      </td>
    </>
  );
};

const renderTransactionTable = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  p-3 ps-4  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.onToggle ? (
          <Checkbox checked={!!tr.selected} onChange={tr.onToggle} />
        ) : (
          checkbox
        )}
      </td>

      <td
        className={`align-middle p-3 ps-0 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex gap-2 p-0">
          <div className="align-self-center">
            {/* Money in and money out read at a glance in the design: a green
                circle with an inbound arrow, a red one with an outbound arrow.
                Falls back to the supplied icon for rows that have no
                direction. */}
            {tr.activityDetails.direction ? (
              <span
                className={`activity-direction activity-direction-${tr.activityDetails.direction}`}
                aria-label={tr.activityDetails.direction === "in" ? "Money in" : "Money out"}
              >
                {tr.activityDetails.direction === "in" ? (
                  <FiArrowDownLeft size={17} />
                ) : (
                  <FiArrowUpRight size={17} />
                )}
              </span>
            ) : (
              <img src={tr.activityDetails.icon} alt="" />
            )}
          </div>
          <div className="d-flex flex-column">
            <span className="fw-medium">{tr.activityDetails.name}</span>

            <span className="fs12px">
              from
              <span className="ps-1" style={{ color: "var(--accent-color)" }}>
                {tr.activityDetails.from}
              </span>
            </span>
          </div>
        </div>
      </td>

      <td
        className={`align-middle p-3  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
          {tr.date}
        </span>
      </td>

      <td
        className={`align-middle p-3 text-center   ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span
          className="fs14px fw-semibold"
          style={{ color: tr.direction === "out" ? "#161616" : "#1bbb6b" }}
        >
          {tr.direction === "out" ? "-" : "+"}${tr.amount}
        </span>
      </td>

      <td
        className={`align-middle p-3    ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.status}
      </td>

      <td
        className={`align-middle  p-3   ${
          key === bodyLength && "border-bottom-0 "
        }`}
      >
        <Button1
          buttonName={"Send again"}
          className={"btn-outline-success"}
          onClick={tr.onSendAgain}
        />
      </td>
    </>
  );
};

const renderStatementTable = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  p-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {checkbox}
      </td>

      <td
        className={`align-middle p-4 ps-0 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex gap-2 p-0 align-items-center">
          <img
            src={tr.billFrom.icon}
            className="image-fluid"
            width={40}
            alt=""
            height={40}
          />

          <span className="fw-medium">{tr.billFrom.name}</span>
        </div>
      </td>

      <td
        className={`align-middle p-4 ps-0 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex gap-2 p-0  align-items-center">
          <img
            src={tr.billTo.icon}
            className="image-fluid"
            width={40}
            height={40}
            alt=""
          />

          <span className="fw-medium">{tr.billTo.name}</span>
        </div>
      </td>

      <td
        className={`align-middle p-4 text-end ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.invoiceNo}
      </td>

      <td
        className={`align-middle p-4  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.dateTime}
      </td>

      <td
        className={`align-middle p-4 text-end fw-semibold ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "var(--accent-color)" }}
      >
        {tr.amount}
      </td>

      <td
        className={`align-middle p-4 text-end  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.category}
      </td>

      <td
        className={`align-middle p-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex flex-wrap gap-2 align-items-center">
          {tr.tags.map((tag) => (
            <span className="fs14px">{tag}</span>
          ))}
          <img src={addIcon} alt="add" className="cursor-pointer" />
        </div>
      </td>

      <td
        className={`align-middle p-4 text-end ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <img src={downloadIcon} alt="download" className="cursor-pointer" />
      </td>
    </>
  );
};

const renderRecipientsTable = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  p-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.onToggle ? (
          <Checkbox checked={!!tr.selected} onChange={tr.onToggle} />
        ) : (
          checkbox
        )}
      </td>

      <td
        className={`align-middle p-4 ps-0 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex gap-2 p-0 flex-wrap flex-md-nowrap justify-content-center justify-content-md-start">
          <img src={tr.recipientData.icon} alt="" width={25} />
          <div className="d-flex flex-column">
            <span className="fw-medium fs14px">
              {tr.recipientData.recipientName}
            </span>

            <span className="fs12px">{tr.recipientData.recipientinfo}</span>
          </div>
        </div>
      </td>

      <td
        className={`align-middle p-4 text-end fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.category}
      </td>

      <td
        className={`align-middle p-4   ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex flex-lg-wrap flex-nowrap align-items-center gap-3">
          {Array.isArray(tr.tags) && tr.tags.map((tag) => {
            return <span className="fs14px">{tag},</span>;
          })}
          <CiCirclePlus className="fs-5 cursor-pointer" color="#1bbb6b" />
        </div>
      </td>

      <td
        className={`align-middle p-4 fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.purpose}
      </td>

      <td
        className={`align-middle p-4 fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.method}
      </td>

      <td
        className={`align-middle p-4 text-end fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.currency}
      </td>

      <td
        className={`align-middle p-4 fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.type}
      </td>
      <td
        className={`align-middle p-4 fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.country}
      </td>
      <td
        className={`align-middle p-4 text-nowrap fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.identifier}
      </td>
    </>
  );
};

const renderEmployeeCardTable = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  p-3 ps-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {checkbox}
      </td>

      <td
        className={`align-middle py-3 ps-0 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex gap-3 p-0 align-items-center">
          <img src={tr.cardType.cardIcon} alt="" />

          <span className="fw-medium fs14px">{tr.cardType.type}</span>
        </div>
      </td>

      <td
        className={`align-middle py-3 fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.purpose}
      </td>

      <td
        className={`align-middle py-3 fs14px  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.nickname}
      </td>

      <td
        className={`align-middle py-3 text-center  fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.category}
      </td>

      <td
        className={`align-middle py-3  ps-2 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex flex-wrap align-items-center gap-3">
          {tr.tags.map((tag) => {
            return <span className="fs14px">{tag},</span>;
          })}
          <CiCirclePlus className="fs-5 cursor-pointer" color="#1bbb6b" />
        </div>
      </td>

      <td
        className={`align-middle py-3 text-center fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.cardNumber}
      </td>

      <td
        className={`align-middle py-3 fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.expiresIn}
      </td>

      <td
        className={`align-middle py-3 fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <SuccessTag tagName={tr.status} />
      </td>
    </>
  );
};

const renderCompanyCardTable = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  p-3 ps-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {checkbox}
      </td>

      <td
        className={`align-middle py-3 ps-0 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex gap-3 p-0 align-items-center">
          <img src={tr.cardType.cardIcon} alt="" />

          <span className="fw-medium fs14px">{tr.cardType.type}</span>
        </div>
      </td>

      <td
        className={`align-middle py-3 fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.purpose}
      </td>

      <td
        className={`align-middle py-3 fs14px   ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.nickname}
      </td>

      <td
        className={`align-middle py-3  fs14px text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.category}
      </td>

      <td
        className={`align-middle py-3  ps-2 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex flex-wrap align-items-center gap-3">
          {tr.tags.map((tag) => {
            return <span className="fs14px">{tag},</span>;
          })}
          <CiCirclePlus className="fs-5 cursor-pointer" color="#1bbb6b" />
        </div>
      </td>

      <td
        className={`align-middle py-3 fs14px text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.cardNumber}
      </td>

      <td
        className={`align-middle py-3 fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.expiresIn}
      </td>

      <td
        className={`align-middle py-3 fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <SuccessTag tagName={tr.status} />
      </td>
    </>
  );
};

const renderCardTransactionTable = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  p-3 ps-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {checkbox}
      </td>

      <td
        className={`align-middle fs14px p-3 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.date_time}
      </td>

      <td
        className={`align-middle p-3 fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.status}
      </td>

      <td
        className={`align-middle p-3 fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.type}
      </td>

      <td
        className={`align-middle p-3 fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.details}
      </td>

      <td
        className={`align-middle p-3 text-center ps-4 fw-semibold ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "var(--accent-color)" }}
      >
        {tr.amount}
      </td>

      <td
        className={`align-middle p-3 fs14px text-center  ps-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.currency}
      </td>

      <td
        className={`align-middle p-3 fs14px text-center ps-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "var(--text-muted)" }}
      >
        {tr.category}
      </td>

      <td
        className={`align-middle p-3 fs14px ${
          key === bodyLength && "border-bottom-0"
        } `}
      >
        <div className="d-flex flex-wrap align-items-center gap-2">
          {tr.tags.map((tag) => {
            return <span>{tag},</span>;
          })}
          <CiCirclePlus className="fs-5 cursor-pointer" color="#1bbb6b" />
        </div>
      </td>
    </>
  );
};

const renderInvoiceCreatedTable = (tableHeaders, tableBody) => {
  return (
    <>
      <div className={` rounded-1  overflow-scroll  border`}>
        <table class="table  m-0" style={{ borderRadius: "5px !important" }}>
          <thead>
            <tr>
              {tableHeaders.map((head, key) => (
                <th
                  key={key}
                  scope="col"
                  className={`fs14px ps-3  ${
                    key === 0 ? "col-5" : "text-center"
                  }`}
                >
                  {head}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableBody.map((td, key) => (
              <tr key={key}>
                <td
                  className={`p-3 fs14px ${
                    key === tableBody.length - 1 && "border-bottom-0"
                  }`}
                >
                  {td.description}
                </td>

                <td
                  className={`p-3 ps-4 text-center fs14px ${
                    key === tableBody.length - 1 && "border-bottom-0"
                  }`}
                >
                  {td.qty}
                </td>

                <td
                  className={`p-3 ps-4 text-center fs14px ${
                    key === tableBody.length - 1 && "border-bottom-0"
                  }`}
                >
                  {td.price}
                </td>

                <td
                  className={`p-3 ps-4 text-center fs14px ${
                    key === tableBody.length - 1 && "border-bottom-0"
                  }`}
                >
                  {td.amount}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

const renderSimilarInvoicesTable = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  ps-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ padding: "1.8rem 0 " }}
      >
        {checkbox}
      </td>

      <td
        className={`align-middle p-4 fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.dateTime}
      </td>
      <td
        className={`align-middle p-4  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.status}
      </td>
      <td
        className={`align-middle p-4  fw-semibold fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "var(--accent-color)" }}
      >
        {tr.amount}
      </td>
    </>
  );
};

const renderMyAccountTable = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  ps-4  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.onToggle ? (<Checkbox checked={!!tr.selected} onChange={tr.onToggle} />) : checkbox}
      </td>

      <td
        className={`align-middle p-3 ps-0 fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex gap-2 p-0 align-items-center">
          <img
            src={tr.from.icon}
            alt=""
            className="image-fluid"
            width={40}
            height={40}
          />
          <div className="d-flex flex-column">
            <span className="fw-medium">{tr.from.name}</span>
            <span className="fw-medium fs12px" style={{ color: "var(--text-muted)" }}>
              {tr.from.info}
            </span>
          </div>
        </div>
      </td>

      <td
        className={`align-middle text-center p-3  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.category}
      </td>

      <td
        className={`align-middle p-3 text-center ps-0 fw-semibold fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex flex-wrap align-items-center gap-2">
          {tr.tags.map((tag) => {
            return <span>{tag},</span>;
          })}
        </div>
      </td>

      <td
        className={`align-middle p-3 text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.lastRefresh}
      </td>

      <td
        className={`align-middle p-3 fw-semibold   text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "var(--accent-color)" }}
      >
        {tr.amount}
      </td>

      <td
        className={`align-middle p-3  ps-0  text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <img
          src={refreshIcon}
          alt="refresh"
          className="cursor-pointer"
          width={17}
          height={17}
        />
      </td>
    </>
  );
};

const renderSpendingReportTable = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle p-3  fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex gap-2 p-0 align-items-center">
          {tr.categoryData.color && (
            <SmallCircle color={tr.categoryData.color} />
          )}
          {tr.categoryData.icon && <img src={tr.categoryData.icon} alt="" />}
          <span className="fw-medium fs-6">{tr.categoryData.name}</span>
        </div>
      </td>

      <td
        className={`align-middle  p-3 pe-5 text-center ps-0  fs-12px ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "var(--text-muted)" }}
      >
        {tr.percentage && `${tr.percentage}%`}
      </td>

      <td
        className={`align-middle p-3 text-start  fw-semibold fs14px ${
          key === bodyLength && "border-bottom-0"
        }`}
        style={{ color: "#FC555B" }}
      >
        {tr.amount}
      </td>
    </>
  );
};

const renderAddBillersTable = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  p-3 ps-4  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {checkbox}
      </td>

      <td
        className={`align-middle p-3  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className=" p-2 px-3  border rounded-3">
          <span className=" fs12px">{tr.billerName}</span>
        </div>
      </td>

      <td
        className={`align-middle p-3  ps-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-medium fs13px" style={{ color: "#EC9F4C" }}>
          {tr.category}
        </span>
      </td>

      <td
        className={`align-middle p-3  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex flex-wrap gap-1 align-items-center">
          {tr.tags.map((tag) => (
            <span className="fs14px">{tag}</span>
          ))}
          <img src={addIcon} alt="add" className="cursor-pointer" />
        </div>
      </td>

      <td
        className={`align-middle p-3  ${
          key === bodyLength && "border-bottom-0 "
        }`}
      >
        <Select
          className="w-auto p-2 fs13px px-3"
          defaultValue={tr.frequency}
        />
      </td>

      <td
        className={`align-middle p-3   ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="p-2 px-3 border rounded-3">
          <span className="fs12px">{tr.nextDueDate}</span>
        </div>
      </td>

      <td
        className={`align-middle p-3    ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className=" p-2 px-3 border rounded-3">
          <span className="fs12px">{tr.amount}</span>
        </div>
      </td>

      <td
        className={`align-middle p-3   ${
          key === bodyLength && "border-bottom-0 "
        }`}
      >
        <Select
          className=" p-2  fs13px px-3"
          defaultValue={tr.paymentMethod}
          options={[
            { name: "Manual Payment", value: "manualpayment" },
            { name: "Direct Credit", value: "directcredit" },
            { name: "Direct Debit", value: "directdebit" },
          ]}
        />
      </td>
    </>
  );
};

const renderBillersTable = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  p-3 ps-4  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {checkbox}
      </td>

      <td
        className={`align-middle p-3  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className=" fs14px fw-medium">{tr.bill}</span>
      </td>

      <td
        className={`align-middle p-3 text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-medium fs13px">{tr.category}</span>
      </td>

      <td
        className={`align-middle p-3  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex flex-wrap gap-1 align-items-center">
          {tr.tags.map((tag) => (
            <span className="fs14px">{tag}</span>
          ))}
          <img src={addIcon} alt="add" className="cursor-pointer" />
        </div>
      </td>

      <td
        className={`align-middle p-3  ${
          key === bodyLength && "border-bottom-0 "
        }`}
      >
        <Select
          className=" p-2  fs13px px-3"
          defaultValue={tr.paymentMethod}
          options={[
            { name: "Manual Payment", value: "manualpayment" },
            { name: "Direct Credit", value: "directcredit" },
            { name: "Direct Debit", value: "directdebit" },
          ]}
        />
      </td>

      <td
        className={`align-middle p-3  ${
          key === bodyLength && "border-bottom-0 "
        }`}
      >
        <Select
          className="w-auto p-2 fs13px px-3"
          defaultValue={tr.frequency}
        />
      </td>

      <td
        className={`align-middle p-3   ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="p-2 px-3 border rounded-3">
          <span className="fs12px">{tr.date}</span>
        </div>
      </td>

      <td
        className={`align-middle p-3    ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <Switch defaultChecked={tr.paid} />
      </td>

      <td
        className={`align-middle p-3   ${
          key === bodyLength && "border-bottom-0 "
        }`}
      >
        <span className="fs14px fw-semibold" style={{ color: "var(--accent-color)" }}>
          {tr.amount}
        </span>
      </td>
    </>
  );
};

const renderMyTransactionTable = (
  tr,
  key,
  bodyLength,
  handleClickTransaction,
  downManager
) => {
  return (
    <>
      <td
        className={`align-middle  p-4   ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.onToggle ? (
          <Checkbox checked={!!tr.selected} onChange={tr.onToggle} />
        ) : (
          checkbox
        )}
      </td>

      <td
        className={`align-middle p-4 ps-3   ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className=" fs14px fw-medium" style={{ color: "var(--text-muted)" }}>
          {tr.dueDate}
        </span>
      </td>

      <td
        className={`align-middle p-4 ps-3   ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-medium fs13px">{tr.bill}</span>
      </td>

      <td
        className={`align-middle p-4 ps-3 text-center  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fs14px fw-semibold" style={{ color: "#F7A64F" }}>
          {tr.subCategory}
        </span>
      </td>

      <td
        className={`align-middle p-4  text-center  ${
          key === bodyLength && "border-bottom-0 "
        }`}
      >
        <span className="fs14px fw-semibold">{tr.asBill}</span>
      </td>

      <td
        className={`align-middle p-4 ps-3    ${
          key === bodyLength && "border-bottom-0 "
        }`}
      >
        <div className="d-flex gap-2  align-items-center">
          <span className="fs14px fw-semibold" style={{ color: "#FC555B" }}>
            {tr.amount}
          </span>
          <img
            src={downIcon}
            alt="down"
            className="cursor-pointer"
            style={{
              transform: `rotate(${downManager ? "180deg" : "0deg"})`,
            }}
            width={18}
            height={18}
            onClick={() => handleClickTransaction(key)}
          />
        </div>
      </td>
    </>
  );
};

const renderAssumptionTable = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  p-3 ps-4  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {checkbox}
      </td>

      <td
        className={`align-middle p-3 ps-0 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex align-items-center gap-2">
          <img src={tr.account.icon} alt="icon" />
          <div className="d-flex flex-column gap-1">
            <span className="fw-medium">{tr.account.name}</span>
            <span className="fs12px fw-medium" style={{ color: "var(--text-muted)" }}>
              {tr.account.accNo}
            </span>
          </div>
        </div>
      </td>

      <td
        className={`align-middle p-3  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="border rounded-3 p-2 px-3">
          <span className="fw-semibold fs14px " style={{ color: "var(--accent-color)" }}>
            {tr.amount}
          </span>
        </div>
      </td>

      <td
        className={`align-middle p-3  ${
          key === bodyLength && "border-bottom-0 "
        }`}
      >
        <Select
          className="w-auto p-2 fs13px px-3"
          defaultValue={tr.invesmentTenor}
        />
      </td>

      <td
        className={`align-middle p-3   ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="p-2 px-3 border rounded-3">
          <span className="fs14px fw-semibold" style={{ color: "var(--accent-color)" }}>
            {tr.estimatedTargeted}
          </span>
        </div>
      </td>

      <td
        className={`align-middle p-3    ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className=" p-2 px-3 border rounded-3">
          <span className="fs14px">{tr.startDate}</span>
        </div>
      </td>

      <td
        className={`align-middle p-3    ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className=" p-2 px-3 border rounded-3">
          <span className="fs14px">{tr.retirementDate}</span>
        </div>
      </td>

      <td
        className={`align-middle p-3   ${
          key === bodyLength && "border-bottom-0 "
        }`}
      >
        <Button1 buttonName={"Compute"} className={"btn-dark"} />
      </td>
    </>
  );
};

const renderCreditScoreInfoTable = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle ps-3 p-4  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fs14px" style={{ color: "var(--text-muted)" }}>
          {tr.category}
        </span>
      </td>

      <td
        className={`align-middle p-4 ps-0  pe-5 text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs-6  " style={{ color: "#FC3C42" }}>
          {tr.impactOnScore}
        </span>
      </td>

      <td
        className={`align-middle ps-3 p-4   ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fs14px " style={{ color: "#79867F" }}>
          {tr.whatInfluencesYourScore}
        </span>
      </td>

      <td
        className={`align-middle ps-3 p-4   ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fs14px " style={{ color: "#79867F" }}>
          {tr.whatCanYouDo}
        </span>
      </td>
    </>
  );
};

const renderAllGroupsTable = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  p-3 ps-4  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {checkbox}
      </td>

      <td
        className={`align-middle p-3 ps-0 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex align-items-center gap-2">
          <img src={tr.groupDetail.icon} alt="icon" />
          <div className="d-flex flex-column gap-1">
            <span className="fw-medium">{tr.groupDetail.name}</span>
            <span className="fs12px fw-medium" style={{ color: "var(--text-muted)" }}>
              {tr.groupDetail.createdOn}
            </span>
          </div>
        </div>
      </td>

      <td
        className={`align-middle p-3 text-center ps-2 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
          {tr.category}
        </span>
      </td>

      <td
        className={`align-middle p-3  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex flex-wrap gap-1 align-items-center">
          {tr.tags.map((tag) => (
            <span className="fs14px">{tag}</span>
          ))}
          <img src={addIcon} alt="add" className="cursor-pointer" />
        </div>
      </td>

      <td
        className={`align-middle p-3    ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fs14px" style={{ color: "var(--text-muted)" }}>
          {tr.lastActivity.amount ? (
            <>
              {tr.lastActivity.paidBy} paid{" "}
              <span className="fw-semibold" style={{ color: "var(--accent-color)" }}>
                {tr.lastActivity.amount}
              </span>{" "}
              to <span style={{ color: "#161616" }}>{tr.lastActivity.paidTo}</span>{" "}
              on {tr.lastActivity.date}
            </>
          ) : (
            "No activity yet"
          )}
        </span>
      </td>

      <td
        className={`align-middle p-3   ${
          key === bodyLength && "border-bottom-0 "
        }`}
      >
        <div className="d-flex justify-content-between align-items-center">
          <span className="fs14px fw-semibold" style={{ color: "var(--accent-color)" }}>
            {tr.totalExpensesnGroup}
          </span>
          <img src={editIcon} alt="edit" className="cursor-pointer" />
        </div>
      </td>
    </>
  );
};

const renderAllExpenseTable = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  p-3 ps-4  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {checkbox}
      </td>

      <td
        className={`align-middle p-3 ps-0 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex align-items-center gap-2">
          <img src={tr.expenseDetail.icon} alt="icon" />

          <span className="fw-medium">{tr.expenseDetail.name}</span>
        </div>
      </td>

      <td
        className={`align-middle p-3 text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
          {tr.createdBy}
        </span>
      </td>

      <td
        className={`align-middle p-3 text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
          {tr.paidBy}
        </span>
      </td>

      <td
        className={`align-middle p-3 text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
          {tr.lastUpdate}
        </span>
      </td>

      <td
        className={`align-middle p-3 text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
          {tr.category}
        </span>
      </td>

      <td
        className={`align-middle p-3  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex flex-wrap gap-1 align-items-center">
          {tr.tags.map((tag) => (
            <span className="fs14px" style={{ color: "var(--text-muted)" }}>
              {tag}
            </span>
          ))}
          <img src={addIcon} alt="add" className="cursor-pointer" />
        </div>
      </td>

      <td
        className={`align-middle p-3 text-center    ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fs14px fw-semibold">{tr.youPaid}</span>
      </td>

      <td
        className={`align-middle p-3 text-center   ${
          key === bodyLength && "border-bottom-0 "
        }`}
      >
        <span className="fs14px fw-semibold" style={{ color: "var(--accent-color)" }}>
          {tr.youLent}
        </span>
      </td>

      <td
        className={`align-middle p-3   ${
          key === bodyLength && "border-bottom-0 "
        }`}
      >
        {tr.status}
      </td>
    </>
  );
};

const renderGroupBalanceTable = (tr, key, bodyLength) => {
  return (
    <>
      <td
        className={`align-middle  p-3 ps-4  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {checkbox}
      </td>

      <td
        className={`align-middle p-3 ps-0 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex align-items-center gap-2">
          {tr.accountInfo.icon ? (
            <img
              src={tr.accountInfo.icon}
              alt="icon"
              width={34}
              className="rounded-circle"
            />
          ) : (
            <span
              className="rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: 34,
                height: 34,
                backgroundColor: "#EDF8F3",
                color: "#1BBB6B",
              }}
            >
              {String(tr.accountInfo.name || "?").slice(0, 1)}
            </span>
          )}
          <div className="d-flex flex-column gap-1">
            <span className="fw-medium">{tr.accountInfo.name}</span>
            <span className="fs12px fw-medium" style={{ color: "var(--text-muted)" }}>
              <span style={{ color: tr.you ? "#1bbb6b" : "#FC3C42" }}>
                {tr.accountInfo.amount}
              </span>{" "}
              in total
            </span>
          </div>
        </div>
      </td>

      <td
        className={`align-middle p-3 text-center ps-0  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
          {tr.category}
        </span>
      </td>

      <td
        className={`align-middle p-3  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex flex-wrap gap-1 align-items-center">
          {tr.tags.map((tag) => (
            <span className="fs14px">{tag}</span>
          ))}
          <img src={addIcon} alt="add" className="cursor-pointer" />
        </div>
      </td>

      <td
        className={`align-middle p-3    ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {tr.description}
      </td>

      <td
        className={`align-middle  p-3   ${
          key === bodyLength && "border-bottom-0 "
        }`}
      >
        <Button2
          buttonName={"Settle Up"}
          className={"btn-dark py-1 px-3"}
          divClassName={"gap-2"}
          icon={<img src={receiptCheck} alt="" />}
        />
      </td>
    </>
  );
};

const renderViewByPersonTable = (tr, key, bodyLength) => {
  const content = (
    <div className="d-flex flex-column gap-3">
      <span className="fs13px cursor-pointer fw-semibold">View Details</span>
      <span className="fs13px cursor-pointer fw-semibold">Settle</span>
      <span className="fs13px cursor-pointer fw-semibold">Request Payment</span>
    </div>
  );
  return (
    <>
      <td
        className={`align-middle  p-3 ps-4  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        {checkbox}
      </td>

      <td
        className={`align-middle p-3 ps-0 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex align-items-center gap-2">
          <img src={tr.groupdetails.icon} alt="icon" />

          <span className="fw-medium">{tr.groupdetails.name}</span>
        </div>
      </td>

      <td
        className={`align-middle p-3  text-center  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
          {tr.expense}
        </span>
      </td>

      <td
        className={`align-middle p-3  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
          {tr.date}
        </span>
      </td>

      <td
        className={`align-middle p-3 text-center  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
          {tr.category}
        </span>
      </td>

      <td
        className={`align-middle p-3  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
          {tr.tags}
        </span>
      </td>

      <td
        className={`align-middle p-3 text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-bold fs14px ">${tr.total}</span>
      </td>

      <td
        className={`align-middle p-3 text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-bold fs14px ">${tr.youPaid}</span>
      </td>

      <td
        className={`align-middle p-3 text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-bold fs14px ">${tr.youShare}</span>
      </td>

      <td
        className={`align-middle p-3 text-center  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-bold fs14px ">${tr.received}</span>
      </td>

      <td
        className={`align-middle p-3 text-center  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-bold fs14px ">${tr.remaining}</span>
      </td>

      <td
        className={`align-middle  p-3  ps-0 ${
          key === bodyLength && "border-bottom-0 "
        }`}
      >
        <Popover
          placement="bottom"
          trigger={"click"}
          content={content}
          arrow={false}
        >
          <span>
            <HorizontalDots className="cursor-pointer" />
          </span>
        </Popover>
      </td>
    </>
  );
};

const renderSplitSummaryTable = (tr, key, bodyLength) => {
  const content = (
    <div className="d-flex flex-column gap-3">
      <span className="fs13px cursor-pointer fw-semibold">View Details</span>
      <span className="fs13px cursor-pointer fw-semibold">Settle</span>
      <span className="fs13px cursor-pointer fw-semibold">Request Payment</span>
    </div>
  );
  return (
    <>
      <td
        className={`align-middle p-3 py-4  text-center  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <div className="d-flex gap-2 align-items-center">
          {checkbox}
          <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
            {tr.date}
          </span>
        </div>
      </td>

      <td
        className={`align-middle pe-3 py-4  text-center ps-4 ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
          {tr.category}
        </span>
      </td>

      <td
        className={`align-middle   ps-4 pe-3 py-4 text-center  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
          {tr.tags}
        </span>
      </td>

      <td
        className={`align-middle p-3 py-4 ps-4 text-center  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
          {tr.group}
        </span>
      </td>

      <td
        className={`align-middle p-3 py-4   ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
          {tr.name}
        </span>
      </td>

      <td
        className={`align-middle p-3 py-4 text-center ps-4  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
          {tr.people}
        </span>
      </td>

      <td
        className={`align-middle p-3 py-4 text-center ps-4  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-semibold fs14px " style={{ color: "var(--text-muted)" }}>
          {tr.paidBy}
        </span>
      </td>

      <td
        className={`align-middle p-3 py-4  text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-bold fs14px ">${tr.total}</span>
      </td>

      <td
        className={`align-middle p-3 py-4  text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-bold fs14px ">${tr.your}</span>
      </td>

      <td
        className={`align-middle p-3 py-4  text-center ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-bold fs14px ">${tr.groupAmount}</span>
      </td>

      <td
        className={`align-middle p-3 py-4  text-center  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span
          className="fw-bold fs14px "
          style={{ color: tr.received < 0 ? "#FC3C42" : "#1bbb6b" }}
        >
          {tr.received < 0 && "-"}$
          {tr.received < 0 ? -tr.received : tr.received}
        </span>
      </td>

      <td
        className={`align-middle p-3 py-4  text-center  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-bold fs14px ">${tr.paid}</span>
      </td>

      <td
        className={`align-middle p-3 py-4 text-center  ${
          key === bodyLength && "border-bottom-0"
        }`}
      >
        <span className="fw-bold fs14px ">${tr.remaining}</span>
      </td>

      <td
        className={`align-middle  p-3 py-4 ps-0  ${
          key === bodyLength && "border-bottom-0 "
        }`}
      >
        <Popover
          placement="bottom"
          trigger={"click"}
          content={content}
          arrow={false}
        >
          <span>
            <HorizontalDots className="cursor-pointer" />
          </span>
        </Popover>
      </td>
    </>
  );
};

const Table = ({
  tableHeaders,
  keyNumber1,
  keyNumber2,
  className,
  tableBody,
  WalletTable1,
  condition1,
  condition2,
  WalletTable2,
  WalletTable3,
  WalletTable4,
  WalletTable5,
  TransactionTable,
  StatementTable,
  RecipientsTable,
  EmployeeCardTable,
  CompanyCardTable,
  CardTransactionTable,
  InvoiceCreatedTable,
  SimilarInvoicesTable,
  SpendingReportTable,
  AddBillersTable,
  BillersTable,
  MyAccountTable,
  MyTransactionTable,
  AssumptionTable,
  CreditScoreInfoTable,
  AllGroupsTable,
  AllExpenseTable,
  GroupBalanceTable,
  ViewByPersonTable,
  SplitSummaryTable,
  maxHeight,
  MyTransactionTags = [],
  initialExpandedRows = {},
}) => {
  const [showData, setShowData] = useState(initialExpandedRows);
  const [showMyTransactionData, setShowMyTransactionData] = useState({});
  const navigate = useNavigate();

  // Function For Wallet Table 2
  const handleClickWallet = (key) => {
    if (showData[key]) {
      setShowData({ ...showData, [key]: false });
    } else {
      setShowData({ ...showData, [key]: true });
    }
  };

  //Function For My Trasaction Table
  const handleClickTransaction = (key) => {
    if (showMyTransactionData[key]) {
      setShowMyTransactionData({ ...showMyTransactionData, [key]: false });
    } else {
      setShowMyTransactionData({ ...showMyTransactionData, [key]: true });
    }
  };

  //Function For Company Card and Employee Card Table
  const onTableClick = () => {
    navigate("/card-summary");
  };

  function tableRowClickFunction(key) {
    if (WalletTable2) {
      handleClickWallet(key);
    } else if (CompanyCardTable || EmployeeCardTable) {
      onTableClick();
    }
  }

  return (
    <>
      {!InvoiceCreatedTable ? (
        <div
          className={`d-flex align-items-center justify-content-center ${
            SimilarInvoicesTable && "h-100"
          } `}
        >
          <div
            className={` rounded-4 d-flex  align-items-start overflow-scroll border border-1 ${className} ${
              SimilarInvoicesTable && "h-100"
            }`}
            style={{ maxHeight: maxHeight }}
          >
            <table className="table m-0">
              <thead>
                <tr className="table-secondary ">
                  {tableHeaders.map((head, key) => {
                    return (
                      <th
                        scope="col"
                        className={`fs12px fw-semibold ps-4 ${
                          key === keyNumber1 || key === keyNumber2
                            ? `${condition1}`
                            : `${condition2}`
                        }`}
                      >
                        {head}
                      </th>
                    );
                  })}
                </tr>
              </thead>

              <tbody>
                {tableBody.map((tr, key) => {
                  const bodyLength = tableBody.length - 1;
                  return (
                    <>
                      <tr
                        className="table-white"
                        onClick={() => tableRowClickFunction(key)}
                        key={key}
                      >
                        {WalletTable1 &&
                          renderWallet1Table(tr, key, bodyLength)}
                        {WalletTable2 &&
                          renderWallet2Table(tr, key, bodyLength)}
                        {WalletTable3 &&
                          renderWallet3Table(tr, key, bodyLength)}
                        {WalletTable4 &&
                          renderWallet4Table(tr, key, bodyLength)}
                        {WalletTable5 &&
                          renderWallet5Table(tr, key, bodyLength)}
                        {TransactionTable &&
                          renderTransactionTable(tr, key, bodyLength)}
                        {StatementTable &&
                          renderStatementTable(tr, key, bodyLength)}
                        {RecipientsTable &&
                          renderRecipientsTable(tr, key, bodyLength)}
                        {EmployeeCardTable &&
                          renderEmployeeCardTable(tr, key, bodyLength)}
                        {CompanyCardTable &&
                          renderCompanyCardTable(tr, key, bodyLength)}
                        {CardTransactionTable &&
                          renderCardTransactionTable(tr, key, bodyLength)}
                        {SimilarInvoicesTable &&
                          renderSimilarInvoicesTable(tr, key, bodyLength)}
                        {MyAccountTable &&
                          renderMyAccountTable(tr, key, bodyLength)}
                        {SpendingReportTable &&
                          renderSpendingReportTable(tr, key, bodyLength)}
                        {AddBillersTable &&
                          renderAddBillersTable(tr, key, bodyLength)}
                        {BillersTable &&
                          renderBillersTable(tr, key, bodyLength)}
                        {MyTransactionTable &&
                          renderMyTransactionTable(
                            tr,
                            key,
                            bodyLength,
                            handleClickTransaction,
                            showMyTransactionData[key]
                          )}
                        {AssumptionTable &&
                          renderAssumptionTable(tr, key, bodyLength)}

                        {CreditScoreInfoTable &&
                          renderCreditScoreInfoTable(tr, key, bodyLength)}
                        {AllGroupsTable &&
                          renderAllGroupsTable(tr, key, bodyLength)}
                        {AllExpenseTable &&
                          renderAllExpenseTable(tr, key, bodyLength)}
                        {GroupBalanceTable &&
                          renderGroupBalanceTable(tr, key, bodyLength)}
                        {ViewByPersonTable &&
                          renderViewByPersonTable(tr, key, bodyLength)}
                        {SplitSummaryTable &&
                          renderSplitSummaryTable(tr, key, bodyLength)}
                      </tr>
                      {/* Another row for wallet 2 table  */}
                      {WalletTable2 && showData[key] && (
                        <tr className={`row${key} `}>
                          <td></td>
                          <td>
                            <div className="d-flex flex-column gap-3">
                              <div className="d-flex flex-column">
                                <span className="fs14px opacity-50">
                                  Account Name
                                </span>
                                <span className="fs14px fw-semibold">
                                  {tr.detail?.accountName || "Not issued"}
                                </span>
                              </div>
                              <div className="d-flex flex-column">
                                <span className="fs14px opacity-50">IBAN</span>
                                <span className="fs14px fw-semibold">
                                  {tr.detail?.iban || "Not issued"}
                                </span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex flex-column gap-3">
                              <div className="d-flex flex-column">
                                <span className="fs14px opacity-50">
                                  Account Number
                                </span>
                                <span className="fs14px fw-semibold">
                                  {tr.detail?.accountNumber || tr.accountNumber || "Not issued"}
                                </span>
                              </div>
                              <div className="d-flex flex-column">
                                <span className="fs14px opacity-50">
                                  Swift Code
                                </span>
                                <span className="fs14px fw-semibold">
                                  {tr.detail?.swiftCode || "Not issued"}
                                </span>
                              </div>
                            </div>
                          </td>
                          <td></td>
                          <td>
                            <div className="d-flex flex-column gap-3">
                              <div className="d-flex flex-column">
                                <span className="fs14px opacity-50">
                                  Account Location
                                </span>
                                <span className="fs14px fw-semibold">
                                  {tr.detail?.accountLocation || "Not issued"}
                                </span>
                              </div>
                              <div className="d-flex flex-column">
                                <span className="fs14px opacity-50">
                                  BIC/SORT/BSB
                                </span>
                                <span className="fs14px fw-semibold">
                                  {tr.detail?.bsb || "Not issued"}
                                </span>
                              </div>
                            </div>
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}

                      {/* Another row for My Transaction Table */}
                      {MyTransactionTable && showMyTransactionData[key] && (
                        <>
                          <tr>
                            <td></td>
                            <td colSpan={"5"} className="pe-4">
                              <div className="d-flex flex-column gap-4">
                                <div className="d-flex justify-content-between align-items-center">
                                  <div
                                    className="d-flex flex-column gap-1 "
                                    style={{ width: "70%" }}
                                  >
                                    <span
                                      className="fs12px"
                                      style={{ color: "var(--text-muted)" }}
                                    >
                                      Full Description
                                    </span>
                                    <span className="fs13px fw-semibold">
                                      Rent With Love - Transfer to Esteban Rome
                                    </span>
                                  </div>

                                  <div
                                    className="d-flex flex-column gap-1"
                                    style={{ width: "30%" }}
                                  >
                                    <span
                                      className="fs12px"
                                      style={{ color: "var(--text-muted)" }}
                                    >
                                      Sub Category
                                    </span>
                                    <span
                                      className="fs13px fw-semibold"
                                      style={{ color: "#F7A64F" }}
                                    >
                                      Rent
                                    </span>
                                  </div>
                                </div>

                                <div className="d-flex justify-content-between align-items-center">
                                  <div
                                    className="d-flex flex-column gap-1 "
                                    style={{ width: "70%" }}
                                  >
                                    <span
                                      className="fs12px"
                                      style={{ color: "var(--text-muted)" }}
                                    >
                                      Account
                                    </span>
                                    <span className="fs13px fw-semibold">
                                      American Express Platinum Edge Credit Card
                                    </span>
                                  </div>

                                  <div
                                    className="d-flex flex-column gap-1  "
                                    style={{ width: "30%" }}
                                  >
                                    <span
                                      className="fs12px"
                                      style={{ color: "var(--text-muted)" }}
                                    >
                                      Merchant
                                    </span>
                                    <span className="fs13px fw-semibold">
                                      Liquoriand
                                    </span>
                                  </div>
                                </div>

                                <div className="d-flex flex-column gap-2">
                                  <div className="d-flex justify-content-between align-items-center">
                                    <span
                                      className="fs12px"
                                      style={{ color: "var(--text-muted)" }}
                                    >
                                      Tags
                                    </span>
                                    <Button2
                                      buttonName={"Edit Tags"}
                                      className={"btn-outline-success p-1 px-3"}
                                      icon={<img src={editIcon} alt="edit" />}
                                      before={false}
                                      divClassName={"gap-2"}
                                    />
                                  </div>

                                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                    {MyTransactionTags.map((tag, key) => (
                                      <div style={{ width: "30%" }} key={key}>
                                        <Checkbox
                                          style
                                          defaultChecked={tag.selected}
                                        >
                                          {tag.name}
                                        </Checkbox>
                                      </div>
                                    ))}
                                  </div>
                                </div>

                                <div className="d-flex flex-column gap-2">
                                  <label
                                    className="fs12px"
                                    style={{ color: "var(--text-muted)" }}
                                  >
                                    Notes
                                  </label>
                                  <Input.TextArea
                                    className="p-3"
                                    placeholder="Add Notes"
                                    autoSize={{ minRows: 2, maxRows: 3 }}
                                  />
                                </div>

                                <div className="d-flex justify-content-between align-items-center">
                                  <Button2
                                    buttonName={"See Tax"}
                                    className={"border p-1 px-3"}
                                    icon={<img src={reportIcon} alt="report" />}
                                    divClassName={"gap-2"}
                                  />
                                  <div className="d-flex gap-2 align-items-center">
                                    <Select
                                      defaultValue="Mark as Bill"
                                      className="bg-black text-white rounded-5 change-down-icon-white"
                                      popupClassName="bg-white text-black"
                                      selectStyle={{ width: "140px" }}
                                    />

                                    <Button2
                                      buttonName={"Hide form"}
                                      className={"btn-outline-success p-1 px-3"}
                                      icon={
                                        <img src={downGreenIcon} alt="down" />
                                      }
                                      divClassName={"gap-2"}
                                      before={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </>
                      )}
                    </>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        renderInvoiceCreatedTable(tableHeaders, tableBody)
      )}
    </>
  );
};

export default Table;
